<template>
  <div>
    <PageTitle v-bind:title="'Base Etyms'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button
            v-if="config.editable"
            variant="primary"
            size="sm"
            :disabled="!$store.getters.checkRole('legam.scripta.baseetym.add')"
            class="float-right mb-4"
            v-b-modal.modal-new-baseetym
          >
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new base etym
          </b-button>
          <b-modal
            v-if="config.editable"
            id="modal-new-baseetym"
            title="New base etym"
            ok-title="Save"
            @ok="saveBaseetym"
            size="lg"
          >
            <BaseEtymNewEdit />
          </b-modal>
          <LegamDataTables v-bind="$data" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
* >>> .tdAction {
  width: 150px;
}
</style>

<script>
// import { mapState } from 'vuex'
import router from "@/router";
import PageTitle from "@/components/PageTitle.vue";
import LegamDataTables from "@/components/LegamDataTables.vue";
import tdColAction from "@/components/tdColAction";
import BaseEtymNewEdit from "@/components/Scripta/BaseEtymNewEdit";
import HelpStore from "@/store/helpstore.js";
import config from '@/config.js'

export default {
  name: "BaseEtyms",
  data() {
    return {
      columns: [
        {
          title: "Form",
          field: "form",
          sortable: true,
          searchable: true,
        },
        {
          title: "Comment",
          field: "comment",
          sortable: true,
          searchable: true,
        },
        {
          title: "Heads",
          field: "heads",
          tdComp: tdColAction,
          sortable: true,
          searchable: true,
          transformData: function (row) {
            return row.heads.map(head => {
              return {
                text: head.form,
                icon: null,
                id: head.id,
                to: {
                  name: "HeadDetails",
                  params: {
                    id: head.id,
                  },
                },
              }
            })
          }
        },
        {
          title: "Action",
          field: "action",
          tdComp: tdColAction,
          thClass: "tdAction",
          transformData: function (row) {
            return [
              {
                text: null,
                icon: "list-ul",
                id: row.id,
                to: {
                  name: "BaseEtymDetails",
                  params: {
                    id: row.id,
                  },
                },
              },
            ];
          },
        },
      ],
      url: "/baseetyms/datatables",
      searchableByColumn: true,
      config: config
    };
  },
  components: {
    PageTitle,
    LegamDataTables,
    BaseEtymNewEdit,
  },
  methods: {
    saveBaseetym() {
      this.$store.dispatch("createBaseetym", HelpStore.item).then((response) => {
        router.push(`/baseetym/${response.data.id}`);
      });
    },
  },
};
</script>
